import React, { useCallback, useEffect, useState } from "react";
import ContentHeading from "../../../components/layout/content/ContentHeading";
import InputTextField from "../../../components/input/inputTextField";
import FilterSelect from "../../../components/select/filterSelect";
import moment from "moment";
import { MenuItem } from "@mui/material";
import TableCustom from "../../../components/table/tableCustom";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { useDispatch, useSelector } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import { useTranslation } from "react-i18next";
import {
  FiberManualRecord,
  RemoveRedEyeOutlined,
  SearchOutlined,
} from "@mui/icons-material";
import CustomStatus from "../../../components/chip/CustomStatus";
import DropdownButton from "../../../components/button/DropdownButton";
import { OnlineLeaveSubmissionApi } from "../../../api/online-leave-submission/online-leave-submission.api";
import { dateTimeToView, dateToView } from "../../../utils/date.utils";
import {
  allStatusLeaveOnlineForApprove,
  handleColorStatusUtilForApprove,
  handleTextStatusUtilForApprove,
} from "../../../utils/statusLeaveRequest";
import { leaveTypeApi } from "../../../api/leave-type/leave-type.api";
import { saveAs } from "file-saver";
import StateComponents from "../../../components/state-component/StateComponents";
import { checkPermission, debouncedApiCall } from "../../../utils/app.utils";
import { LeaveReportQuery, ReportApi } from "../../../api/report/Report.api";
import { RootState } from "../../../store/store";

type Props = {};

const OnlineLeaveSubmissionRequest: React.FC<Props> = (props: Props) => {
  const navigate: NavigateFunction = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const profileReducer = useSelector((state: RootState) => state.profile.profile);
  const permission: any[] = profileReducer?.permission || [];
  const checkPermit = checkPermission('OnlineLeaveSubmissionRequest', permission);

  const [dataOnlineLeaveSubmission, setDataOnlineLeaveRequest] = useState([]);
  const [dataLeaveType, setDataLeaveType] = useState<any[]>([]);


  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");


  const [inputValueSearch, setInputValueSearch] = useState({
    name: "",
    leave_type: "",
    status: "all",
  });
  const [search, set_search] = useState<string>("");


  const [dataStatus, _setDataStatus] = useState(allStatusLeaveOnlineForApprove);

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(
    dataOnlineLeaveSubmission.length
  );
  const [sortBy, setSortBy] = useState<string>("created_date");
  const [sortType, setSortType] = useState<string>("DESC");
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const headCells = [
    {
      id: "#",
      width: 2,
      disablePadding: false,
      align: "center",
      label: "#",
    },
    {
      id: "fullname",
      width: 50,
      disablePadding: false,
      align: "start",
      label: t("MANAGE_ONLINE_LEAVE_SUBMISSION.COLUMN.FULLNAME"),
    },
    {
      id: "indentification_number",
      disablePadding: false,
      width: 75,
      align: "center",
      label: t("MANAGE_ONLINE_LEAVE_SUBMISSION.COLUMN.IDENTIFICATION_NUMBER"),
    },
    {
      id: "position",
      disablePadding: false,
      align: "center",
      width: 25,
      label: t("MANAGE_ONLINE_LEAVE_SUBMISSION.COLUMN.POSITION"),
    },
    {
      id: "leave_type",
      disablePadding: false,
      align: "center",
      width: 40,
      label: t("MANAGE_ONLINE_LEAVE_SUBMISSION.COLUMN.LEAVE_TYPE"),
    },
    {
      id: "request_period",
      disablePadding: false,
      align: "center",
      width: 75,
      label: t("MANAGE_ONLINE_LEAVE_SUBMISSION.COLUMN.LEAVE_REQUEST_PERIOD"),
    },
    {
      id: "date_request_submission",
      disablePadding: false,
      align: "center",
      width: 50,
      label: t("MANAGE_ONLINE_LEAVE_SUBMISSION.COLUMN.DATE_REQUEST_SUBMISSION"),
    },
    {
      id: "status",
      disablePadding: false,
      align: "center",
      width: 100,
      label: t("MANAGE_ONLINE_LEAVE_SUBMISSION.COLUMN.STATUS"),
    },
    {
      id: "action",
      disablePadding: false,
      align: "center",
      width: 15,
      label: "",
    },
  ];

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      id_leave,
      leave_start_date,
      leave_end_date,
      leave_status,
      created_date,
      first_name,
      last_name,
      employee_no,
      start_date,
      position_name,
      leave_type_name,
    } = objData;

    const objRenderData = {
      key: id_leave,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "center",
          label: `${no}` || "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: `${first_name} ${last_name}` || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: employee_no || "-",
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: position_name || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: leave_type_name || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label:
            dateToView(leave_start_date, false) +
            "-" +
            dateToView(leave_end_date, false) || " - ",
        },
        {
          option: "TEXT",
          align: "center",
          label: created_date ? dateTimeToView(created_date, false) : "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <CustomStatus
              label={handleTextStatusUtilForApprove(leave_status)}
              type="outlined"
              color={handleColorStatusUtilForApprove(leave_status)}
              icon={<FiberManualRecord />}
              width="250px"
            />
          ),
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <>
              {checkPermit.isView && (
                <RemoveRedEyeOutlined
                  onClick={() => {
                    navigate(
                      routeName.cms.OnlineLeaveSubmissionRequest +
                      `/${id_leave}/approve`
                    );
                  }}
                  style={{
                    cursor: "pointer",
                  }}
                />
              )}

            </>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  const handleChangeValueSearch = (name: string, value: any) => {
    setInputValueSearch((prev: any) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const getLeaveRequestOnlines = useCallback(async () => {
    let query: any = {
      leave_status: inputValueSearch.status,
      page: page,
      limit: pageLimit,
      sortBy: sortBy,
      sortType: sortType,
    };
    if (startDate) query.leave_start_date = moment(startDate).format("YYYY-MM-DD");
    if (endDate) query.leave_end_date = moment(endDate).format("YYYY-MM-DD");
    if (search) query.keyword = search;
    if (inputValueSearch.leave_type) query.id_leave_type = inputValueSearch.leave_type
    await OnlineLeaveSubmissionApi.getRequestForApprove(query).then((res) => {
      if (res.status < 300) {
        const data = res.data;
        setTotalItems(res.data?.data?.meta?.totalItems || 0);
        const newData = data.data.items.map((item: any) => {
          return {
            id_leave: item.id_leave,
            leave_start_date: item.leave_start_date ?? null,
            leave_end_date: item.leave_end_date ?? null,
            leave_status: item.leave_status,
            created_date: item.created_date,
            id_employee: item.employee.id_employee,
            title: item.employee.title,
            first_name: item.employee.first_name,
            last_name: item.employee.last_name,
            employee_no: item.employee.employee_no,
            start_date: item.employee.work?.start_date ?? null,
            position_name: item.employee.work?.position?.position_name ?? "-",
            leave_type_name: item.leave_type?.leave_type_name,
          };
        });
        setDataOnlineLeaveRequest(newData);
      } else {
        setDataOnlineLeaveRequest([]);
      }
    }).catch((err) => {
      console.log(err);
    })
  }, [page, pageLimit, sortBy, sortType, startDate, endDate, search, inputValueSearch.leave_type])


  useEffect(() => {
    dispatch(setLoading());
    setTimeout(() => {
      dispatch(unsetLoading());
    }, 500);
  }, []);

  useEffect(() => {
    getLeaveRequestOnlines();
  }, [getLeaveRequestOnlines]);

  const getLeaveType = async () => {
    let query: any = {
      page: 1,
      limit: 100,
    };
    const res = await leaveTypeApi.getAllLeaveType(query);
    const data = res.data;
    if (data.status < 300) {
      setDataLeaveType(data.data.items);
    } else {
      setDataLeaveType([]);
    }
  };

  useEffect(() => {
    getLeaveType();
  }, []);

  // const handleDownloadFile = async (export_type: string) => {
  //   let query: any = {
  //     page: page,
  //     limit: pageLimit,
  //     sortBy: sortBy,
  //     sortType: sortType,
  //     type: export_type,
  //   };
  //   dispatch(setLoading());
  //   await OnlineLeaveSubmissionApi.GetDownloadFile(query)
  //     .then((res) => {
  //       if (res.status < 300) {
  //         const response = res.data;

  //         // Get the content type from the server's response headers
  //         const contentType = res.headers["content-type"];

  //         // Create a Blob with the content type from the response
  //         const blob = new Blob([response], { type: contentType });

  //         // Extract file extension based on content type
  //         const fileExtension = getFileExtension(contentType || "");

  //         // Generate a filename with the correct extension (you can also modify this to use a custom name)
  //         const fileName = `attachment-leave-request-${new Date().getTime()}.${fileExtension}`;

  //         // Save the file
  //         saveAs(blob, fileName);
  //       }
  //     })
  //     .catch((error) => console.log(error))
  //     .finally(() => dispatch(unsetLoading()));
  // };



  const handleDownloadReport = async (report_type: "pdf" | "excel") => {
    let query: LeaveReportQuery = {
      page: page,
      limit: pageLimit,
      type_file: report_type
    };
    if (search) query.keyword = search;
    if (startDate) query.leave_start_date = startDate;
    if (endDate) query.leave_end_date = endDate;
    if (inputValueSearch.status) query.leave_status = inputValueSearch.status
    dispatch(setLoading());
    await ReportApi.reportLeaveManagement(query).then((res) => {
      if (res.status < 300) {
        const response = res.data;
        const type_file = report_type === 'pdf' ? 'application/pdf' : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        const blob_file = new Blob([response], {
          type: type_file
        })
        saveAs(blob_file, t('รายงานระบบส่งใบลาออนไลน์') + "_" + moment().format("LL"))
      }
    }).catch((err) => {
      console.log(err)
    }).finally(() => {
      dispatch(unsetLoading());
    })
  }

  return (
    <div>
      <ContentHeading
        title={
          "MANAGE_ONLINE_LEAVE_SUBMISSION.TOPIC.ONLINE_LEAVE_SUBMISSION_SYSTEM"//จัดการคำร้องขอลา
        }
        detail="MANAGE_ONLINE_LEAVE_SUBMISSION.TOPIC.SELECT_ITEM_YOU_WANT"
      />

      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 md:col-span-6 lg:col-span-3 sm:col-span-12">
          <InputTextField
            startAdornment={<SearchOutlined />}
            placeholder={t("ค้นหาชื่อ - นามสกุล/ชื่อฉายา")}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              // handleChangeValueSearch("name", e.target.value);
              debouncedApiCall({ searchItem: e.target.value, setItem: set_search })
            }}
          // value={inputValueSearch.name}
          />
        </article>

        <article className="w-full col-span-12 md:col-span-6 lg:col-span-3 sm:col-span-12">
          {/* <InputNewRangePicker
            value={selectedDateRange}
            onchange={handleRangeDate}
            onClear={handleClearRangeDate}
            allowClear
          /> */}
          <StateComponents
            typeProps={[
              {
                seq: 1,
                gridProps: {
                  xs: 12
                },
                type: "DATE_RANGE2",
                fieldProps: {
                  handleChange: (st, end) => {
                    setStartDate(st || "");
                    setEndDate(end || "")
                  },
                  value: {
                    start_date: startDate,
                    end_date: endDate
                  },
                  placeholder: t("ช่วงวันที่")
                }
              }
            ]}
          />
        </article>

        <article className="w-full col-span-12 md:col-span-6 lg:col-span-2 sm:col-span-12">
          <FilterSelect
            value={inputValueSearch.leave_type ?? ""}
            labelId="courses-id"
            selectId="courses-select-id"
            options={[
              {
                id_leave_type: "",
                leave_type_name: t("รูปแบบการลาทังหมด"),
              },
              ...dataLeaveType,
            ].map((list, index) => (
              <MenuItem value={list.id_leave_type} key={index + 1}>
                {list.leave_type_name}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChangeValueSearch("leave_type", e.target.value)
            }
          />
        </article>
        <article className="w-full col-span-12 md:col-span-6 lg:col-span-2 sm:col-span-12">
          <FilterSelect
            value={inputValueSearch.status ?? ""}
            labelId="status-id"
            selectId="status-select-id"
            options={dataStatus.map((list, index) => (
              <MenuItem value={list.id} key={index + 1}>
                {list.name}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChangeValueSearch("status", e.target.value)
            }
          />
        </article>
        <article className="w-full col-span-12 md:col-span-6 lg:col-span-2 sm:col-span-12">
          <DropdownButton
            buttonName={t(
              "MANAGE_ONLINE_LEAVE_SUBMISSION.COMMON.BUTTON.DOWNLOAD_FILE"
            )}
            menuItems={[
              {
                id: 1,
                name: "pdf",
                onClick: () => {
                  handleDownloadReport("pdf");
                },
              },
              {
                id: 2,
                name: "excel",
                onClick: () => {
                  handleDownloadReport("excel");
                },
              },
            ]}
            fullWidth={true}
          />
        </article>
      </div>

      <section className="w-full mt-10">
        <TableCustom
          tableMinWidth={1440}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={
            dataOnlineLeaveSubmission &&
            dataOnlineLeaveSubmission.map((data: any, i: any) => {
              return renderData(data, i);
            })
          }
          onSort={handleRequestSort}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>
    </div>
  );
};

export default OnlineLeaveSubmissionRequest;
